import { render } from "./channelManagar.vue?vue&type=template&id=5809d4d4"
import script from "./channelManagar.vue?vue&type=script&lang=js"
export * from "./channelManagar.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/channel/channelManagar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5809d4d4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5809d4d4', __exports__)) {
    console.log('reload')
    api.reload('5809d4d4', __exports__)
  }
  
  module.hot.accept("./channelManagar.vue?vue&type=template&id=5809d4d4", () => {
    console.log('re-render')
    api.rerender('5809d4d4', render)
  })

}


export default __exports__